export function GuestInviteBar() {
  return (
      <div class={"guest-invite-bar"} id={"guest-invite-bar"} hidden>
        <div class={"guest-invite-bar-copy"}>
          <strong id={"guest-invite-bar-title"}>
            {"Вы смотрите группу как гость"}
          </strong>
          <span id={"guest-invite-bar-text"}>
            {"Зарегистрируйтесь, чтобы вступить и открыть задания."}
          </span>
        </div>
        <div class={"guest-invite-bar-actions"}>
          <button type={"button"} class={"button primary small"} id={"guest-invite-register"}>
            {"Зарегистрироваться"}
          </button>
          <button type={"button"} class={"button small"} id={"guest-invite-login"}>
            {"Войти"}
          </button>
        </div>
      </div>
  );
}
